import { apiCall } from '../api';
import { showToast } from '../utils';

function getEl<T extends HTMLElement>(id: string): T | null {
  return document.getElementById(id) as T | null;
}

interface ParserGroupRow {
  group_key: string;
  parser_name: string;
  in_db: boolean;
  db_group_id: number | null;
  db_group_name: string | null;
  db_product_type: string | null;
  has_attributes: boolean;
  attr_count: number;
}

export async function loadAdminParserGroups(): Promise<void> {
  const container = getEl<HTMLElement>('admin-parser-groups-container');
  if (!container) return;

  const data = await apiCall('/api/admin/parser/groups', 'GET');
  if (!data || !data.groups) {
    container.innerHTML = '<div class="warning">Не удалось загрузить группы</div>';
    return;
  }

  const groups: ParserGroupRow[] = data.groups;
  if (groups.length === 0) {
    container.innerHTML = '<div class="info">Парсер не вернул группы</div>';
    return;
  }

  let html = `<table class="ref-table">
    <thead>
      <tr>
        <th>Ключ</th>
        <th>Название (парсер)</th>
        <th>В БД</th>
        <th>Атрибуты</th>
        <th>Product type</th>
        <th>Действия</th>
      </tr>
    </thead>
    <tbody>`;

  groups.forEach((g) => {
    const productType = g.db_product_type ?? '';
    const inDbBadge = g.in_db
      ? '<span style="color:#2e7d32; font-weight:600;">✓</span>'
      : '<span style="color:#c62828; font-weight:600;">—</span>';
    const attrBadge = g.has_attributes
      ? `<span title="Атрибутов: ${g.attr_count}">${g.attr_count}</span>`
      : '<span style="color:#999;">0</span>';
    const syncBtn = g.in_db
      ? `<button data-action="syncParserGroup" data-group-key="${escapeAttr(g.group_key)}" title="Пересинхронизировать атрибуты">🔄</button>`
      : `<button data-action="syncParserGroup" data-group-key="${escapeAttr(g.group_key)}">➕ Добавить</button>`;
    const typeInput = g.in_db
      ? `<input type="text" value="${escapeAttr(productType)}" data-action="updateParserGroupField" data-group-key="${escapeAttr(g.group_key)}" data-field="product_type" style="width:140px;">`
      : '<span style="color:#999;">—</span>';

    html += `<tr>
      <td>${escapeHtml(g.group_key)}</td>
      <td>${escapeHtml(g.parser_name)}</td>
      <td style="text-align:center;">${inDbBadge}</td>
      <td style="text-align:center;">${attrBadge}</td>
      <td>${typeInput}</td>
      <td>${syncBtn}</td>
    </tr>`;
  });

  html += '</tbody></table>';
  container.innerHTML = html;
}

(window as any).loadAdminParserGroups = loadAdminParserGroups;

(window as any).syncParserGroup = async function (groupKey: string): Promise<void> {
  const res = await apiCall('/api/admin/parser/groups/sync', 'POST', {
    group_keys: [groupKey],
  });
  if (res && res.success) {
    showToast(
      `Группа синхронизирована. Добавлено групп: ${res.stats.groups_added || 0}, атрибутов: ${res.stats.attrs_added || 0}`,
      'success'
    );
    await loadAdminParserGroups();
  }
};

(window as any).syncAllParserGroups = async function (): Promise<void> {
  const res = await apiCall('/api/admin/parser/groups/sync', 'POST', {});
  if (res && res.success) {
    showToast(
      `Синхронизация завершена. Групп: ${res.stats.groups_added || 0}, атрибутов: ${res.stats.attrs_added || 0}`,
      'success'
    );
    await loadAdminParserGroups();
  }
};

(window as any).updateParserGroupField = async function (
  groupKey: string,
  field: string,
  value: string
): Promise<void> {
  const res = await apiCall(`/api/admin/parser/groups/${encodeURIComponent(groupKey)}`, 'PUT', {
    [field]: value,
  });
  if (res && res.success) {
    showToast('Сохранено', 'success');
  }
};

(window as any).restartParser = async function (): Promise<void> {
  if (!confirm('Перезапустить парсер? Это сбросит его внутренний кэш и может занять несколько секунд.')) {
    return;
  }
  const res = await apiCall('/api/admin/parser/groups/restart', 'POST', {});
  if (res && res.success) {
    showToast('Парсер перезапущен', 'success');
    await loadAdminParserGroups();
  }
};

function escapeHtml(text: string): string {
  return text
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#039;');
}

function escapeAttr(text: string): string {
  return text.replace(/"/g, '&quot;');
}
